/** ترجمه و آیکون فعالیت‌های پروژه */

export const PROJECT_ACTIVITY_EMPTY = 'هیچ فعالیتی ثبت نشده است.';

const ACTIVITY_FA = {
  'messages.addedAsNewProject': 'به عنوان پروژه جدید اضافه شد.',
  'messages.updateSuccess': 'با موفقیت به‌روزرسانی شد.',
  'messages.newFileUploadedToTheProject': 'فایل جدید در پروژه آپلود شد.',
  'messages.newTaskAddedToTheProject': 'کار جدید به پروژه اضافه شد.',
  'messages.newMilestoneCreated': 'نقطه عطف جدید ایجاد شد.',
  'messages.milestoneUpdated': 'نقطه عطف به‌روزرسانی شد.',
  'messages.milestoneDeleted': 'نقطه عطف حذف شد.',
  'messages.isAddedAsProjectMember': 'به عنوان عضو پروژه اضافه شد.',
  'modules.tasks.timerStartedBy': 'تایمر شروع شد.',
  'modules.tasks.timerStoppedBy': 'تایمر متوقف شد.',
  'modules.tasks.timerPausedBy': 'تایمر موقتاً متوقف شد.',
};

const MEMBER_EN_SUFFIX = /is added as a project member\.?$/i;
const MEMBER_FA_SUFFIX = /به[\u200c\s]*عنوان عضو پروژه اضافه شد\.?$/;

/**
 * متن خام activity را به فارسی قابل‌نمایش تبدیل می‌کند.
 */
export const translateProjectActivity = (raw) => {
  if (raw == null || raw === '') return '—';
  const text = String(raw).trim();
  if (ACTIVITY_FA[text]) return ACTIVITY_FA[text];

  // کلید ترجمه به‌همراه نام: «Ali is added as a project member.»
  if (MEMBER_EN_SUFFIX.test(text)) {
    const name = text.replace(MEMBER_EN_SUFFIX, '').trim();
    return name
      ? `${name} ${ACTIVITY_FA['messages.isAddedAsProjectMember']}`
      : ACTIVITY_FA['messages.isAddedAsProjectMember'];
  }

  // متن از قبل فارسی (مثلاً با نیم‌فاصله)
  if (MEMBER_FA_SUFFIX.test(text) || /[\u0600-\u06FF]/.test(text)) {
    return text;
  }

  // کلیدهایی مثل messages.xxx که در دیکشنری نبودند
  if (/^(messages|modules)\./.test(text)) {
    const key = text.split('.').pop();
    return ACTIVITY_FA[text] || key || text;
  }

  return text;
};

/**
 * @returns {'file'|'task'|'milestone'|'member'|'timer'|'update'|'project'|'default'}
 */
export const getProjectActivityKind = (raw) => {
  const text = String(raw || '');
  const key = text.includes('.') ? text : '';
  const lower = text.toLowerCase();

  if (
    key.includes('newFileUploaded') ||
    lower.includes('file uploaded') ||
    text.includes('فایل')
  ) {
    return 'file';
  }
  if (
    key.includes('newTaskAdded') ||
    lower.includes('new task') ||
    text.includes('کار جدید')
  ) {
    return 'task';
  }
  if (
    key.toLowerCase().includes('milestone') ||
    lower.includes('milestone') ||
    text.includes('نقطه عطف')
  ) {
    return 'milestone';
  }
  if (
    key.includes('isAddedAsProjectMember') ||
    MEMBER_EN_SUFFIX.test(text) ||
    MEMBER_FA_SUFFIX.test(text) ||
    text.includes('عضو پروژه')
  ) {
    return 'member';
  }
  if (key.includes('timer') || lower.includes('timer') || text.includes('تایمر')) {
    return 'timer';
  }
  if (
    key.includes('addedAsNewProject') ||
    lower.includes('new project') ||
    text.includes('پروژه جدید')
  ) {
    return 'project';
  }
  if (
    key.includes('updateSuccess') ||
    lower.includes('updated') ||
    text.includes('به‌روزرسانی')
  ) {
    return 'update';
  }
  return 'default';
};

export default translateProjectActivity;
